module.exports = __webpack_public_path__ + "static/media/exhibition-services-img22.eb266915.jpg";